import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import { ActivityCalendar } from 'react-activity-calendar';
import { FiActivity, FiAward, FiBox, FiBriefcase, FiCalendar, FiCheckCircle, FiClock, FiLoader, FiLogOut, FiMapPin, FiMoreVertical, FiPlus, FiThumbsUp, FiTrendingUp, FiUser, FiUserPlus, FiX } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import styles from '../Dashboard.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';
import HQDialog from '../../HQDialog/HQDialog';
import HQToast from '../../HQToast/HQToast';

export default class DashboardExperience extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			nickname: this.props.nickname || '',

			errorText: '',

            isLoadingExperience: false,
            isSavingExperience: false,

            experienceErrorText: '',

            saveExperienceErrorText: '',

			isAddEditExperienceDialogOpen: false,

            newExperienceText: '',
			editingExperienceUserEntityID: null,

			openExperienceMenuID: 0,

            deletingExperienceIDs: [],
            confirmDeleteExperienceID: 0,

			experienceList: [],
		};

		this.experienceMenuRefs = {};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		document.addEventListener('mousedown', this.onDocumentPointerDown);
		document.addEventListener('touchstart', this.onDocumentPointerDown);

        this.loadExperienceData();
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onDocumentPointerDown);
		document.removeEventListener('touchstart', this.onDocumentPointerDown);
	};

	// normalizeCalendarData = (graph) => {
	// 	const maxCount = graph.reduce((max, item) => {
	// 		return Math.max(max, item.count || 0);
	// 	}, 0);

	// 	return graph.map((item) => {
	// 		const count = Number(item.count) || 0;

	// 		let level = 0;
	// 		if (count > 0 && maxCount > 0) {
	// 			level = Math.min(4, Math.max(1, Math.ceil((count / maxCount) * 4)));
	// 		}

	// 		return {
	// 			date: item.day,
	// 			count,
	// 			level,
	// 		};
	// 	});
	// };

	loadExperienceData = () => {
        const userID = utils.getCurrentUserID();

		this.setState({
			isLoadingExperience: true,
			experienceErrorText: '',
		});

		utils.sendRequest('/entity/getUserExperienceList', { nickname: this.state.nickname })
			.then((responseData) => {
				this.setState({
					isLoadingExperience: false,
					experienceList: responseData.experienceList || [],
				});
			})
			.catch((error) => {
				console.log('experience load error', error);
				this.setState({
					isLoadingExperience: false,
					experienceErrorText: 'Could not load experience right now.',
				});
			});
	};

	openAddExperienceDialog = () => {
		this.setState({
			isAddEditExperienceDialogOpen: true,
			editingExperienceUserEntityID: null,
			newExperienceText: '',
			saveExperienceErrorText: '',
		});
	};

	closeAddExperienceDialog = () => {
		this.setState({
			isAddEditExperienceDialogOpen: false,
			editingExperienceUserEntityID: null,
			saveExperienceErrorText: '',
		});
	};

	getExperienceUserEntityID = (item) => {
		if (!item) {
			return null;
		}

		const userEntityID = Number(item.userEntityId);
		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			return null;
		}

		return userEntityID;
	};

	onNewExperienceTextChange = (event) => {
		this.setState({
			newExperienceText: event.target.value,
		});
	};

	isExperienceDeleting = (userEntityID) => {
		return (this.state.deletingExperienceIDs || []).includes(userEntityID);
	};

	setExperienceMenuRef = (userEntityID, node) => {
		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			return;
		}

		if (node) {
			this.experienceMenuRefs[userEntityID] = node;
			return;
		}

		delete this.experienceMenuRefs[userEntityID];
	};

	onDocumentPointerDown = (event) => {
		const openExperienceMenuID = Number(this.state.openExperienceMenuID);

		if (Number.isInteger(openExperienceMenuID) && openExperienceMenuID > 0) {
			const activeExperienceMenuRoot = this.experienceMenuRefs[openExperienceMenuID];

			if (!activeExperienceMenuRoot || !activeExperienceMenuRoot.contains(event.target)) {
				this.setState({
					openExperienceMenuID: 0,
				});
			}
		}
	};

	toggleExperienceMenu = (userEntityID) => {
		this.setState((prevState) => ({
			openExperienceMenuID: prevState.openExperienceMenuID === userEntityID ? 0 : userEntityID,
		}));
	};

	openEditExperienceDialog = (item) => {
		const userEntityID = this.getExperienceUserEntityID(item);

		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			return;
		}

		this.setState({
			openExperienceMenuID: 0,
			isAddEditExperienceDialogOpen: true,
			editingExperienceUserEntityID: userEntityID,
			newExperienceText: item.rawUserEntityText || '',
			saveExperienceErrorText: '',
		});
	};

	openDeleteExperienceDialog = (item) => {
		const userEntityID = this.getExperienceUserEntityID(item);

		if (!Number.isInteger(userEntityID) || userEntityID <= 0 || this.isExperienceDeleting(userEntityID)) {
			return;
		}

		this.setState({
			openExperienceMenuID: 0,
			confirmDeleteExperienceID: userEntityID,
		});
	};

	closeDeleteExperienceDialog = () => {
		this.setState({
			confirmDeleteExperienceID: 0,
		});
	};

	onDeleteExperienceDialogPrimaryClick = () => {
		const userEntityID = Number(this.state.confirmDeleteExperienceID);

		this.setState({
			confirmDeleteExperienceID: 0,
		}, () => {
			this.deleteExperience(userEntityID);
		});
	};

	deleteExperience = (userEntityIDInput) => {
		const userEntityID = Number(userEntityIDInput);

		if (!Number.isInteger(userEntityID) || userEntityID <= 0 || this.isExperienceDeleting(userEntityID)) {
			return;
		}

		this.setState((prevState) => ({
			openExperienceMenuID: 0,
			confirmDeleteExperienceID: 0,
			deletingExperienceIDs: Array.from(new Set([...prevState.deletingExperienceIDs, userEntityID])),
			experienceErrorText: '',
		}), () => {
			utils.sendRequest('/entity/deleteExperience', {
				userEntityID,
			})
				.then(() => {
					this.setState((prevState) => ({
						experienceList: prevState.experienceList.filter((experience) => Number(experience.userEntityId) !== userEntityID),
						deletingExperienceIDs: prevState.deletingExperienceIDs.filter((currentUserEntityID) => currentUserEntityID !== userEntityID),
					}));
				})
				.catch((error) => {
					console.log('delete experience error', error);

					this.setState((prevState) => ({
						deletingExperienceIDs: prevState.deletingExperienceIDs.filter((currentUserEntityID) => currentUserEntityID !== userEntityID),
						experienceErrorText: error && error.message ? error.message : 'Could not delete the experience right now.',
					}));
				});
		});
	};

	onAddExperienceSave = () => {
		const userID = utils.getCurrentUserID();
		const normalizedExperienceText = (this.state.newExperienceText || '').trim();
		const userEntityID = Number(this.state.editingExperienceUserEntityID);
		const normalizedUserEntityID = Number.isInteger(userEntityID) && userEntityID > 0 ? userEntityID : null;

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				saveExperienceErrorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		if (normalizedExperienceText === '') {
			this.setState({
				saveExperienceErrorText: 'Please enter your work experience details before adding.',
			});
			return;
		}

		this.setState({
			isAddEditExperienceDialogOpen: false,
			isSavingExperience: true,
			openExperienceMenuID: 0,
			saveExperienceErrorText: '',
			newExperienceText: '',
		}, () => {
			utils.sendRequest('/entity/saveExperience', {
				userEntityID: normalizedUserEntityID,
				experience: normalizedExperienceText,
			})
				.then(() => {
					this.setState({
						isSavingExperience: false,
						editingExperienceUserEntityID: null,
					});

					this.loadExperienceData();
				})
				.catch((error) => {
					console.log('save experience error', error);
					this.setState({
						isSavingExperience: false,
						editingExperienceUserEntityID: null,
						saveExperienceErrorText: 'Could not add experience right now. Please try again shortly.',
					});
				});
		});
	};

	// getLatestActiveDate = () => {
	// 	const {
	// 		contributionGraph,
	// 	} = this.state;

	// 	for (let index = contributionGraph.length - 1; index >= 0; index--) {
	// 		if ((contributionGraph[index].count || 0) > 0) {
	// 			return contributionGraph[index].date;
	// 		}
	// 	}

	// 	return 'No activity yet';
	// };

	formatDate = (value) => {
		if (!value) {
			return 'Unknown';
		}

		const date = new Date(value);
		if (Number.isNaN(date.getTime())) {
			return 'Unknown';
		}

		return date.toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'short',
			// day: 'numeric', // don't show day
		});
	};

	formatDateRange = (startDate, endDate) => {
		const startLabel = startDate ? this.formatDate(startDate) : 'Unknown';
		const endLabel = endDate ? this.formatDate(endDate) : 'Present';

		if (startLabel === 'Unknown' && endLabel === 'Unknown') {
			return 'Dates not available';
		}

		return `${startLabel} - ${endLabel}`;
	};

	renderDeleteExperienceDialog = () => {
		const userEntityID = Number(this.state.confirmDeleteExperienceID);

		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			return null;
		}

		const dialogNode = (
			<HQDialog
				title="Delete Experience"
				message="Are you sure you want to delete this experience item?"
				primaryButtonText="Delete"
				onPrimaryClick={this.onDeleteExperienceDialogPrimaryClick}
				onCancelClick={this.closeDeleteExperienceDialog}
				isPrimaryDisabled={this.isExperienceDeleting(userEntityID)}
			/>
		);

        const portalNode = typeof this.props.getDialogPortalNode === 'function'
            ? this.props.getDialogPortalNode()
            : this.props.dialogPortalNode;

        if (portalNode) {
            return ReactDOM.createPortal(dialogNode, portalNode);
        }

        return dialogNode;
	};

	renderAddEditExperienceDialog = () => {
		const {
			isAddEditExperienceDialogOpen,
			newExperienceText,
			editingExperienceUserEntityID,
		} = this.state;

		if (!isAddEditExperienceDialogOpen) {
			return null;
		}

		const dialogNode = (
			<div className={styles.dialogOverlay} onClick={this.closeAddExperienceDialog}>
				<div className={styles.dialogCard} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-experience-title">
					<button
						type="button"
						className={styles.dialogCloseButton}
						onClick={this.closeAddExperienceDialog}
						aria-label="Close add experience dialog"
					>
						<FiX />
					</button>

					<h3 id="add-experience-title" className={styles.dialogTitle}>{editingExperienceUserEntityID ? 'Edit Experience' : 'Add New Experience'}</h3>
					<p className={styles.dialogSubtitle}>Tell us about your work experience: company name, city, state, ZIP, your role, and start and end date (or if you still work there)</p>

					<textarea
						className={styles.dialogTextarea}
						value={newExperienceText}
						onChange={this.onNewExperienceTextChange}
						placeholder="Company name, city, state, ZIP, your role, and start and end date (or if you still work there)"
						rows={6}
					/>

					<div className={styles.dialogActions}>
						<button
							type="button"
							className={`${styles.primaryButton} ${styles.dialogPrimaryButton}`}
							onClick={this.onAddExperienceSave}
						>
							{editingExperienceUserEntityID ? 'Save' : 'Add'}
						</button>
					</div>
				</div>
			</div>
		);

        const portalNode = typeof this.props.getDialogPortalNode === 'function'
            ? this.props.getDialogPortalNode()
            : this.props.dialogPortalNode;

        if (portalNode) {
            return ReactDOM.createPortal(dialogNode, portalNode);
        }

        return dialogNode;
	};

    render() {
		const {
			isLoadingExperience,
			isSavingExperience,
			openExperienceMenuID,
			experienceErrorText,
			saveExperienceErrorText,
			experienceList,
			editingExperienceUserEntityID,
		} = this.state;

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiBriefcase /> Experience</h2>
					<p className={styles.formText}>Career history linked to verified entity records and role updates.</p>
					{isSavingExperience && (
						<div className={styles.statusText}>
							{editingExperienceUserEntityID ? 'Saving your work experience updates' : 'Adding your new work experience'}
						</div>
					)}
				</div>

				{experienceErrorText !== '' && <div className={styles.errorBox}>{experienceErrorText}</div>}
				{saveExperienceErrorText !== '' && <div className={styles.errorBox}>{saveExperienceErrorText}</div>}

				{isLoadingExperience && <div className={styles.loadingBox}>Loading experience records...</div>}

				{!isLoadingExperience && experienceList.length === 0 && (
					<div className={styles.emptyBox}>No experience records were found for this profile.</div>
				)}

				{!isLoadingExperience && experienceList.length > 0 && (
					<div className={styles.profileList}>
						{experienceList.map((item) => {
							const userEntityID = this.getExperienceUserEntityID(item);
							const isMenuOpen = openExperienceMenuID === userEntityID;
							const canEditExperience = userEntityID !== null;
							const isDeletingExperience = Number.isInteger(userEntityID) ? this.isExperienceDeleting(userEntityID) : false;

							return (
								<article key={`${item.entityId}-${item.role}-${item.startDate || 'start'}`} className={`${styles.profileCard}${isDeletingExperience ? ` ${styles.updateCardDeleting}` : ''}`}>
									<div className={styles.profileCardHeader}>
										<div className={styles.profileCardHeadingGroup}>
											<h3 className={styles.profileCardTitle}>{item.name || 'Unnamed organization'}</h3>
											<p className={styles.profileCardSubtitle}>{item.role || 'Role not set'}</p>
										</div>
										<div className={styles.updateActions} ref={(node) => this.setExperienceMenuRef(userEntityID, node)}>
											<span className={styles.profileCardBadge}><FiCalendar /> {this.formatDateRange(item.startDate, item.endDate)}</span>
											{canEditExperience && (
												<>
													<button
														type="button"
														className={styles.updateMenuButton}
														onClick={() => this.toggleExperienceMenu(userEntityID)}
														aria-label="Open experience actions"
														aria-expanded={isMenuOpen}
														disabled={isDeletingExperience}
													>
														<FiMoreVertical />
													</button>

													{isMenuOpen && (
														<div className={styles.updateMenu} role="menu" aria-label="Experience actions">
															<button
																type="button"
																className={styles.updateMenuItem}
																onClick={() => this.openEditExperienceDialog(item)}
																disabled={isDeletingExperience}
																role="menuitem"
															>
																Edit Experience
															</button>
															<button
																type="button"
																className={styles.updateMenuItemDelete}
																onClick={() => this.openDeleteExperienceDialog(item)}
																disabled={isDeletingExperience}
																role="menuitem"
															>
																Delete
															</button>
														</div>
													)}
												</>
											)}
										</div>
									</div>

									<p className={styles.profileCardBody}>{item.description || 'No experience description available.'}</p>

									<div className={styles.profileCardMetaRow}>
										{/* <span className={styles.profileCardMetaChip}><FiMapPin /> {item.location || 'Remote'}</span> */}
										<span className={styles.profileCardMetaChip}><FiMapPin /> {[item.city, item.state, item.country].filter(Boolean).join(', ') || 'Location not listed'}</span>
										{/* <span className={styles.profileCardMetaChip}><FiClock /> {this.formatDate(item.startDate)} - {item.endDate ? this.formatDate(item.endDate) : 'Present'}</span> */}
									</div>
								</article>
							);
						})}
					</div>
				)}

				<div className={styles.sectionFooterActions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={this.openAddExperienceDialog}
					>
						<FiPlus /> Add Experience
					</button>
				</div>

                {this.renderDeleteExperienceDialog()}
                {this.renderAddEditExperienceDialog()}
			</>
		);
	};
};